/**
 * LOOP BUNDLE CART DRAWER RE-INITIALIZER
 *
 * Purpose:
 * Loop Subscriptions renders bundle rows in the cart drawer only once on initial page load.
 * When Dawn updates the cart via AJAX (quantity changes, removals, additions), the cart
 * drawer HTML is re-rendered and the Loop-rendered bundle rows disappear.
 *
 * This script:
 * - Hooks into all Shopify cart mutation requests (add/change/update) by wrapping `fetch()`
 * - Re-fetches the cart JSON after each mutation
 * - Refreshes `window.Loop.bundleCartAllItems`
 * - Removes any previously rendered bundle rows
 * - Re-runs `initLoopBundle()` to re-render grouped bundle rows in the cart drawer
 *
 * Key goals:
 * - Prevent bundle rows from disappearing after cart updates
 * - Avoid modifying Loop’s generated bundle script (safe from app updates)
 * - Avoid page reloads and rely on Dawn’s native AJAX cart behavior
 *
 * Notes:
 * - `initLoopBundle` is defined by Loop as a top-level const, not always attached to `window`
 * - This script calls it directly and guards against race conditions and duplicate runs
 * - The re-init is debounced and locked to prevent infinite loops
 *
 * Dependencies:
 * - Loop bundle snippet must already be loaded
 * - Shopify cart must use fetch-based AJAX (standard for Dawn and modern themes)
 *
 * Client ID:
 *   LOOP_ng5mpk-q1_bundles_drawer
 *
 * Last updated: 2026-01-10
 */


(function () {
  "use strict";

  var LF_LOOP_CLIENT_ID = "LOOP_ng5mpk-q1_bundles_drawer";
  var LF_IS_RUNNING = false;

  function lfLog(msg) {
    console.log("[LF Loop Reinit] " + msg);
  }

  function lfRemoveExistingRenderedBundleRows() {
    var parent = document.querySelector("." + LF_LOOP_CLIENT_ID);
    if (!parent) return;

    var rendered = parent.querySelectorAll('tr[id^="CartBundleItem-"]');
    for (var i = 0; i < rendered.length; i++) {
      rendered[i].remove();
    }
  }

  function lfFetchCartItems() {
    return fetch(window.Shopify.routes.root + "cart.js", {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return (cart && cart.items) ? cart.items : []; });
  }

  function lfReInitLoopBundleDrawer(reason) {
    if (LF_IS_RUNNING) return;
    if (window.location.pathname.indexOf("/a/loop_subscriptions/bundle") !== -1) return;

    // IMPORTANT: initLoopBundle might not be on window
    if (typeof initLoopBundle !== "function") {
      lfLog("Skipped, initLoopBundle not available yet. Reason: " + (reason || "unknown"));
      return;
    }

    LF_IS_RUNNING = true;
    lfLog("Re-init starting. Reason: " + (reason || "unknown"));

    lfFetchCartItems()
      .then(function (items) {
        window.Loop = window.Loop || {};
        window.Loop.bundleCartAllItems = items;

        lfRemoveExistingRenderedBundleRows();

        window.setTimeout(function () {
          try {
            initLoopBundle(LF_LOOP_CLIENT_ID);
            setTimeout(function () {
  lfAddH4ToBundleTitles();
}, 100);



            lfLog("Re-init called initLoopBundle()");
          } catch (e) {
            console.warn("[LF Loop Reinit] initLoopBundle failed:", e);
          }
          LF_IS_RUNNING = false;
        }, 50);
      })
      .catch(function (e) {
        console.warn("[LF Loop Reinit] cart fetch failed:", e);
        LF_IS_RUNNING = false;
      });
  }

  function lfIsCartMutationUrl(url) {
    if (!url) return false;
    var u = String(url);
    if (u.indexOf("/cart/add") !== -1) return true;
    if (u.indexOf("/cart/change") !== -1) return true;
    if (u.indexOf("/cart/update") !== -1) return true;
    return false;
  }

function lfAddH4ToBundleTitles() {
  var parent = document.querySelector("." + LF_LOOP_CLIENT_ID);
  if (!parent) {
    console.log("Bundle titles found: 0 (parent missing)");
    return;
  }

  var rows = parent.querySelectorAll('a.cart-item__name');
  console.log("Bundle titles found:", rows.length);

  for (var i = 0; i < rows.length; i++) {
    rows[i].classList.add("h4");
  }
}

  function lfInstallFetchHook() {
    if (!window.fetch || window.fetch.__lf_loop_hooked) return;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var url = arguments[0];
      var isCartMutation = lfIsCartMutationUrl(url);

      return originalFetch.apply(this, arguments).then(function (res) {
        if (isCartMutation) {
          window.setTimeout(function () {
            lfReInitLoopBundleDrawer("fetch " + url);
          }, 150);
        }
        return res;
      });
    };

    window.fetch.__lf_loop_hooked = true;
    lfLog("Installed fetch hook");
  }

  lfInstallFetchHook();

  window.setTimeout(function () {
    lfReInitLoopBundleDrawer("initial safety run");
  }, 300);
})();
